export default __webpack_public_path__ + "static/media/ic-playlist-file-attach.18a1b52a.svg";